/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import {
    IAppInsights,
    IEventTelemetry,
    IExceptionTelemetry,
    IMetricTelemetry,
    IPageViewTelemetry,
    ITraceTelemetry,
} from "@microsoft/applicationinsights-web";
import ITelemetryClient, { CustomProperties } from "./ITelemetryClient";

export default class TelemetryClient implements ITelemetryClient {
    private readonly appInsightsPromise: Promise<IAppInsights>;

    constructor(appInsightsPromise: Promise<IAppInsights>) {
        this.appInsightsPromise = appInsightsPromise;
    }

    public trackEvent(event: IEventTelemetry, customProperties?: CustomProperties): void {
        this.appInsightsPromise.then((appInsightsTelemetryClient) => {
            appInsightsTelemetryClient.trackEvent(event, customProperties);
        });
    }

    public trackPageView(pageView: IPageViewTelemetry, customProperties?: CustomProperties): void {
        this.appInsightsPromise.then((appInsightsTelemetryClient) => {
            appInsightsTelemetryClient.trackPageView(pageView, customProperties);
        });
    }

    public trackException(
        exception: IExceptionTelemetry,
        customProperties?: CustomProperties
    ): void {
        this.appInsightsPromise.then((appInsightsTelemetryClient) => {
            appInsightsTelemetryClient.trackException(exception, customProperties);
        });
    }

    public trackTrace(trace: ITraceTelemetry, customProperties?: CustomProperties): void {
        this.appInsightsPromise.then((appInsightsTelemetryClient) => {
            appInsightsTelemetryClient.trackTrace(trace, customProperties);
        });
    }

    public trackMetric(metric: IMetricTelemetry, customProperties?: CustomProperties): void {
        this.appInsightsPromise.then((appInsightsTelemetryClient) => {
            appInsightsTelemetryClient.trackMetric(metric, customProperties);
        });
    }
}
